import React, { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import LoginLeftSection from 'components/loginLeftSection/LoginLeftSection';
import Button from 'components/button/Button';
import userImage from 'assets/images/image1.png';
import CustomModal from 'components/customModal/CustomModal';
import Styles from './UploadProfile.module.scss';

interface UploadProfileProps {
}
const UploadProfile: FunctionComponent<UploadProfileProps> = (props: UploadProfileProps) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [image, setImage] = useState<any>('');
  const [isOpen, setIsOpen] = useState(false);
  const [shouldRenderModal, setShouldRenderModal] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [alert, setAlert] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [shakeUpload, setShakeUpload] = useState(false);
  const history = useHistory();

  const changeImage = (e: any) => {
    const fileType = e.target.files[0].type;
    const type = fileType.split('/');
    if (type[0] === 'image') {
      setAlert(false);
      setSelectedImage(e.target.files[0]);
      setShowWarning(false);
    } else {
      setSelectedImage(null);
      setAlert(true);
    }
  };

  const showGuideLine = () => {
    document.body.classList.add('modal-open');
    setShouldRenderModal(true);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setTimeout(() => {
      document.body.classList.remove('modal-open');
      setShouldRenderModal(false);
    }, 300);
  };

  const handleConfirm = () => {
    setIsOpen(false);
    setTimeout(() => {
      document.body.classList.remove('modal-open');
      setShouldRenderModal(false);
    }, 300);
  };

  useEffect(() => {
    if (selectedImage) {
      setImage(selectedImage);
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [selectedImage]);

  const handleNext = () => {
    if (!selectedImage) {
      setShowWarning(true);
      setShakeUpload(true);
      setTimeout(() => {
        setShakeUpload(false);
      }, 600);
      return;
    }
    history.push('/registration/step-four', { profileImage: image });
  };

  const handleSkip = () => {
    history.push('/registration/step-four', { profileImage: null });
  };

  const modalContent = () => (
    <>
      <p className={`text-center text-black fontSixteen font-weight-normal ${Styles.modalText}`}>
        Take a picture that clearly shows your face and is well lit. Natural light greatly improves profile pics. The
        picture must be of you and not someone else. Your profile will be shown to the host when making a request to
        join a room.
      </p>
      <div className={Styles.userImagesWrapper}>
        <img src={userImage} alt="user img" />
        <img src={userImage} alt="user img" />
        <img src={userImage} alt="user img" />
        <img src={userImage} alt="user img" />
        <img src={userImage} alt="user img" />
        <img src={userImage} alt="user img" />
      </div>
      <div className="text-center">
        <Button label="GOT IT!" clickHandler={handleConfirm} cssClass={Styles.gotButtonWidth} />
      </div>
    </>
  );

  return (
    <section className={Styles.customContainer}>
      <div className={Styles.leftSectionWrapper}>
        <LoginLeftSection />
      </div>
      <div className={Styles.rightSectionWrapper}>
        <div className={Styles.loginArea}>
          <div className={Styles.formContent}>
            <div className={Styles.stepBlock}>
              <p className={Styles.stepLabel}>STEP 3</p>
              <p className={Styles.stepSubtitle}>Add a profile picture</p>
            </div>

            <p className={Styles.tagLine}>
              Or take a picture using the app. Don't sweat it, you can change it later.
            </p>

            <button className={Styles.guidelinesLink} onClick={showGuideLine} type="button">
              SEE OUR SELFIE PROFILE PICTURE GUIDELINES
              <i className="fas fa-long-arrow-alt-right" />
            </button>

            <div className={`${Styles.uploadCard} ${shakeUpload ? Styles.shakeUpload : ''}`}>
              <div className={Styles.uploadCircle}>
                {selectedImage ? (
                  <img src={URL.createObjectURL(selectedImage)} alt="upload file" className={Styles.uploadImage} />
                ) : (
                  <i className={`fas fa-camera ${Styles.cameraIcon}`} />
                )}
                <input type="file" accept="image/*" onChange={(e) => changeImage(e)} />
              </div>
              <p className={Styles.takePictureLabel}>
                <i className="fas fa-camera" />
                TAKE A PICTURE
              </p>
              {showWarning && <p className={Styles.uploadWarning}>Please upload a profile picture to continue</p>}
            </div>

            {alert && <p className={Styles.error}>Only Accept Image (.jpg, .jpeg, .png) etc</p>}

            <div className={Styles.btnBlock}>
              <Button clickHandler={handleNext} label="NEXT" disabled={disabled} />
            </div>

            <button className={Styles.skipLink} onClick={handleSkip} type="button">
              Skip
            </button>
          </div>
        </div>
      </div>
      {shouldRenderModal && (
        <CustomModal
          closeDialog={closeDialog}
          wrapperClass={Styles.modalWrapperClass}
          title="Selfie Profile Picture Guidelines"
          isOpen={isOpen}
        >
          {modalContent()}
        </CustomModal>
      )}
    </section>
  );
};

export default UploadProfile;
